/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import PropTypes from 'prop-types';
import fastDeepEqual from 'fast-deep-equal/es6/react';
import { constants } from '@sitecore-jss/sitecore-jss';
export const SitecoreContextReactContext = React.createContext({});
export const ComponentFactoryReactContext = React.createContext({});
export class SitecoreContext extends React.Component {
    constructor(props) {
        var _a, _b, _c, _d;
        super(props);
        /**
         * Update context state. Value can be @type {LayoutServiceData} which will be automatically transformed
         * or you can provide exact @type {SitecoreContextValue}
         * @param {SitecoreContextValue | LayoutServiceData} value New context value
         */
        this.setContext = (value) => {
            this.setState({
                context: value.sitecore
                    ? this.constructContext(value)
                    : Object.assign({}, value),
            });
        };
        const context = this.constructContext(props.layoutData);
        let api = props.api;
        if (((_b = (_a = props.api) === null || _a === void 0 ? void 0 : _a.edge) === null || _b === void 0 ? void 0 : _b.contextId) && !((_d = (_c = props.api) === null || _c === void 0 ? void 0 : _c.edge) === null || _d === void 0 ? void 0 : _d.edgeUrl)) {
            api = Object.assign(Object.assign({}, props.api), { edge: Object.assign(Object.assign({}, props.api.edge), { edgeUrl: constants.SITECORE_EDGE_URL_DEFAULT }) });
        }
        this.state = {
            context,
            setContext: this.setContext,
            api,
        };
    }
    constructContext(layoutData) {
        var _a;
        if (!layoutData) {
            return {
                pageEditing: false,
            };
        }
        return Object.assign({ route: layoutData.sitecore.route, itemId: (_a = layoutData.sitecore.route) === null || _a === void 0 ? void 0 : _a.itemId }, layoutData.sitecore.context);
    }
    componentDidUpdate(prevProps) {
        // In case if somebody will manage SitecoreContext state by passing fresh `layoutData` prop
        // instead of using `updateSitecoreContext`
        if (!fastDeepEqual(prevProps.layoutData, this.props.layoutData)) {
            this.setContext(this.props.layoutData);
            return;
        }
    }
    render() {
        return (React.createElement(ComponentFactoryReactContext.Provider, { value: this.props.componentFactory },
            React.createElement(SitecoreContextReactContext.Provider, { value: this.state }, this.props.children)));
    }
}
SitecoreContext.propTypes = {
    children: PropTypes.any.isRequired,
    componentFactory: PropTypes.func,
    layoutData: PropTypes.shape({
        sitecore: PropTypes.shape({
            context: PropTypes.any,
            route: PropTypes.any,
        }),
    }),
};
SitecoreContext.displayName = 'SitecoreContext';
